export const List = ({ children }) => {
    return <ul className="d-inline-block m-0 list-unstyled col-12 col-md-6">{children}</ul>;
};
